// extracted by mini-css-extract-plugin
export var container = "contact-module--container--j2CHD";
export var formContainer = "contact-module--formContainer--xJ0kc";
export var formControl = "contact-module--formControl--kv+5x";
export var formField = "contact-module--formField--RPssi";
export var formFieldTextarea = "contact-module--formFieldTextarea--W9nsn";
export var formSendIcon = "contact-module--formSendIcon--6FsIj";
export var formSubmit = "contact-module--formSubmit--4TLbC";
export var textContainer = "contact-module--textContainer--yH3N0";